// @ts-expect-error Could not find a declaration file for module
import InfoButtonModalOpener from '../../../containers/AcademyToSoftware/InfoButtonModalOpener';
import { useLessonDisplayCategories, useTrackDisplayCategories } from '..';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const TrackCategoryInfoButton = ({
  trackId
}) => {
  const {
    trackDisplayCategories
  } = useTrackDisplayCategories({
    trackId
  });
  if (!trackDisplayCategories) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: trackDisplayCategories.map(label => /*#__PURE__*/_jsx(InfoButtonModalOpener, {
      className: "m-left-2",
      selectedSoftware: label.toLowerCase()
    }, label))
  });
};
export const LessonCategoryInfoButton = ({
  lessonId
}) => {
  const {
    lessonDisplayCategories
  } = useLessonDisplayCategories({
    lessonId
  });
  if (!lessonDisplayCategories) return null;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: lessonDisplayCategories.map(label => /*#__PURE__*/_jsx(InfoButtonModalOpener, {
      className: "m-left-2",
      selectedSoftware: label.toLowerCase()
    }, label))
  });
};